import OutsourcersPage from "modules/agents/outsourcers/components/OutsourcersPage";
import { ProtectedRoute } from "modules/common/components/routing/ProtectedRoute";
import { routes } from "modules/common/routes";
import { canAny } from "modules/session/auth/access";
import { SessionType } from "modules/session/auth/models/session";
import React from "react";
import { RouteObject } from "react-router-dom";
import { AgentsTabsPage } from "./components/AgentsTabsPage";
import functionalities from "./functionalities";
import { OutsourcersStoreType } from "./outsourcers/models/outsourcers-store";

const READ = Object.values(functionalities).filter((func) => func.endsWith("_READ"));

export const buildRoutes = ({ session, outsourcers, baseUrl }: RoutesProps): RouteObject[] => {
  const { loggedIn, access } = session;
  const visible = canAny(READ, access);

  return [
    {
      path: `${routes.agents.path}/*`,
      element: (
        <ProtectedRoute loggedIn={loggedIn}>
          {visible ? (
            <AgentsTabsPage
              outsourcersPanel={
                canAny(
                  [
                    functionalities.OUTSOURCER_READ,
                    functionalities.CLIENT_READ,
                    functionalities.SUPPLIER_READ,
                    functionalities.AGENT_READ,
                  ],
                  access
                ) ? (
                  <OutsourcersPage store={outsourcers} access={access} isLegalEntities={true} baseUrl={baseUrl} />
                ) : null
              }
            />
          ) : null}
        </ProtectedRoute>
      ),
    },
  ];
};

interface RoutesProps {
  baseUrl: string;
  outsourcers: OutsourcersStoreType;
  session: SessionType;
}
